import Phaser from "phaser";

import type { FoodRuntime } from "../application/food-runtime";
import type { BotRuntime } from "../application/bot-runtime";
import type { FirstRunHint } from "../application/first-run-hint";
import type { PlayerRuntime } from "../application/player-runtime";
import type { TailClipRuntime } from "../application/tail-clip-runtime";
import type { BonusRuntime } from "../application/bonus-runtime";
import type { CoinRewardFeedbackPort } from "../application/coin-reward-feedback";
import type { MotionProfile } from "../config/motion-config";
import type { ArenaBackgroundId } from "../config/arena-background-config";
import type { JoystickSafeAreaInsets } from "./virtual-joystick-input";
import type { SeasonalChallengeDescriptor } from "../config/seasonal-challenge-config";
import { BootScene } from "./boot-scene";

export const createGameConfig = (
  runtime: PlayerRuntime,
  foodRuntime: FoodRuntime,
  botRuntime: BotRuntime,
  firstRunHint: FirstRunHint,
  getMotionProfile: () => MotionProfile,
  bonusRuntime: BonusRuntime,
  tailClipRuntime?: TailClipRuntime,
  coinRewardFeedback?: CoinRewardFeedbackPort,
  getArenaBackgroundId?: () => ArenaBackgroundId,
  getSafeAreaInsets?: () => JoystickSafeAreaInsets,
  getSeasonalArenaDescriptor?: () => SeasonalChallengeDescriptor | null,
  getHighContrastPreference?: () => boolean,
): Phaser.Types.Core.GameConfig => ({
  backgroundColor: "#102a43",
  disableContextMenu: true,
  height: 820,
  input: {
    activePointers: 2,
  },
  parent: "game-root",
  scene: new BootScene(
    runtime,
    foodRuntime,
    botRuntime,
    firstRunHint,
    getMotionProfile,
    bonusRuntime,
    tailClipRuntime,
    coinRewardFeedback,
    getArenaBackgroundId,
    getSafeAreaInsets,
    getSeasonalArenaDescriptor,
    getHighContrastPreference,
  ),
  scale: {
    autoCenter: Phaser.Scale.CENTER_BOTH,
    mode: Phaser.Scale.RESIZE,
  },
  type: Phaser.CANVAS,
  width: 1180,
});
